import {Component, Input} from '@angular/core';
import {InfoModalComponent} from "../../views/modal/info_modal.component";
import {AlertComponent} from "../../views/modal/alert.component";
import {ModalService} from "../../views/modal/base_modal.component";
import {TranslateService} from "../../translate/translate.service";
import {FilterFormService} from "../../views/filter_form/filter_form.service";
import {HelperService} from "../../lib/helper.service";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {AccessorService} from "./accessor.service";
import {getUrlParams} from "../../lib/lib";
import merge from "lodash-es/merge";

@Component({
	template: `
		<info-modal [title]="title" (onOk)="ok()">
			<loading [isLoad]="!stats || (stats && stats.length == 0)"></loading>

			<i class="fa fa-download" aria-hidden="true" (click)="download()"></i>

			<hr>

			<table class="table">
				<thead>
					<th>{{ 'adminstat.common.Date' | translate }}</th>
					<th>{{ 'adminstat.common.Site' | translate }}</th>
					<th>{{ 'adminstat.support.accessor.action' | translate }}</th>
					<th>{{ 'adminstat.support.accessor.Category' | translate }}</th>
					<th>{{ 'adminstat.support.accessor.Subject' | translate }}</th>
				</thead>

				<tbody>
					<tr *ngFor="let stat of stats" [style]="stat.mark == 'accessor | defer site' ? 'background-color:rgba(243, 123, 96, 0.6); color:white;' : ''">
						<td>
							{{ stat.time }}
						</td>
						
						<td>
							{{ stat.url }}
						</td>
						
						<td>
							{{ 'adminstat.support.accessor.' + stat.mark | translate }}
						</td>
						
						<td>
							{{ stat.category }}
						</td>
						
						<td>
							{{ stat.subject }}
						</td>
					</tr>
				</tbody>
			</table>
		</info-modal>
	`
})
export class AccessorPersonalStatsModalComponent extends InfoModalComponent {
	stats;
	email: string;
	
	constructor(
		public activeModal: NgbActiveModal,
		public helper: HelperService,
		public translate: TranslateService,
		public modalService: ModalService,
		public filter: FilterFormService,
		public service: AccessorService
	) {
		super(activeModal);
	}

	ok() {
		this.close();
	}
	
	download() {
		let params: string = getUrlParams(
			merge(
				this.filter.filterParams,
				{
					accessorEmail: this.email,
					start: this.filter.filterParams.accessorDateFilter.start,
					end: this.filter.filterParams.accessorDateFilter.end
				}
			)
		);

		window.location.href = `${this.service.dp.baseRoute}/accessor2/stats_download?${params}`;

		this.modalService.open(AlertComponent, {
			title: 'INFO',
			message: this.translate.__A('common.download file')
		});
	}
}
